module.exports = __webpack_public_path__ + "static/media/0020.1dea6523.jpg";